import { ContentItemViewNodesType } from 'components/WorkspaceEditor/types'
import { TrackChangeType } from 'models/changes'

/**
 * Checks if article text already exists in workspace (case-insensitive, excludes hidden articles)
 * @param {string} text - Text to validate
 * @param {Partial<ContentItemViewNodesType>[]} contentNodes - Workspace content nodes
 * @returns {boolean} true if duplicate found
 */
export const isDuplicateArticle = (
    text: string,
    contentNodes: Partial<ContentItemViewNodesType>[]
): boolean => {
    // Guard against invalid input
    if (!contentNodes || !Array.isArray(contentNodes)) {
        return false
    }

    // Filter for visible articles only
    const articles = contentNodes.filter(
        (node) => node.textType === 'Article' && !node.isHidden
    )

    // Normalize input text for case-insensitive comparison
    const normalizedText = text.trim().toLowerCase()

    return articles.some((node) => {
        // Single element comparison - most common case
        if (node.elements?.[0]?.text?.trim().toLowerCase() === normalizedText) {
            return true
        }

        // Multi-element comparison - concatenate non-deleted elements
        if (node.elements && node.elements.length > 1) {
            const fullText = node.elements
                .filter(
                    (element) => element.changeType !== TrackChangeType.DELETED
                )
                .map((element) => element.text || '')
                .join('')
                .toLowerCase()

            return fullText === normalizedText
        }

        return false
    })
}
